import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stageActions from '../../../actions/stages';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';
import moment from 'moment';
import SeasonSelection from '../../../components/season/season-select';

class StagesContainer extends Component {

  constructor(props) {
    super(props);
    const currentSeason = window.CARE_CONFIG.settings.season;
    this.state = {
      page: 0,
      season: currentSeason ? currentSeason.id : ''
    };
  }

  componentWillMount() {
    this.fetch({});
  }

  removeStage(stage) {
    if (confirm(LocalizedStrings.doYouWantToRemove)) {
      this.props.actions.deleteStage(stage);
    }
  }

  fetch(params) {
    const fetchParams = {
      ...this.state,
      ...params
    };
    this.setState(fetchParams);
    this.props.actions.loadStages(fetchParams.page, fetchParams.size, {
      season: fetchParams.season
    });
  }

  onFilterChange(filterValues) {
    this.fetch({
      season: filterValues
        ? filterValues
        : null,
      page: 0
    });
  }

  render() {
    const {items, total, page, loading, total_pages} = this.props.stages;

    var config = {
      cols: [
        {
          value: 'name',
          header: LocalizedStrings.name
        }, {
          value: (item) => {
            return moment(item.stage_date).format('YYYY-MM-DD HH:mm')
          },
          header: LocalizedStrings.date
        }, {
          value: (item) => {
            return item.season.name
          },
          header: LocalizedStrings.season
        }, {
          value: 'address',
          header: LocalizedStrings.address
        }, {
          value: (item) => {
            return (
              <div className="btn-group">
                <Link to={`/admin/stages/${item.id}`} className="btn">{LocalizedStrings.edit}</Link>
                <Link className="btn"
                      to={`/admin/stages/${item.id}/results`}>{LocalizedStrings.results}</Link>
                <Link className="btn"
                      to={`/admin/stages/${item.id}/participants-upload`}>{LocalizedStrings.uploadParticipants}</Link>
                <a className="btn btn-red"
                   onClick={this.removeStage.bind(this, item)}>{LocalizedStrings.delete}</a>

              </div>
            )

          },
          header: LocalizedStrings.actions
        }
      ]
    };
    return (
      <div>
        <h3 className="first-uppercase">{LocalizedStrings.stages}</h3>
        <div className="table-actions-row">
          <Link to="/admin/stages/new" className="btn btn-primary">
            {LocalizedStrings.newStage}
          </Link>
        </div>
        <div className="panel">
          <div className="panel-body">
            <fieldset className="filters">
              <legend>{LocalizedStrings.filters}</legend>
              <form>
                <div className="inline-fields">
                  <div className="two-selects">
                    <SeasonSelection
                      field={{
                        value: this.state.season,
                        onChange: this.onFilterChange.bind(this)
                      }}/>
                  </div>
                </div>
              </form>
            </fieldset>

            <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages}
                       loadAction={this.fetch.bind(this)} loading={loading}/>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(function (state) {
  return {stages: state.stage.stagesPaginated};
}, function (dispatch) {
  return {
    actions: bindActionCreators({
      ...stageActions
    }, dispatch)
  };
})(StagesContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/stage/stages-container.js